module.exports = __webpack_public_path__ + "static/img/logo.c7118db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 0